import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';
import { NewLanguageStore, CreateLanguageDto } from 'stores/configuration/locations/languages-store';
import { nameof } from 'utils/object';

interface NewLanguageViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newLanguage?: NewLanguageStore;
}

// tslint:disable-next-line:no-empty-interface
interface NewLanguageViewState {
  userClickedSaved: boolean;
}

@connect(['newLanguage', NewLanguageStore])
class NewLanguageView extends React.Component<NewLanguageViewProps, NewLanguageViewState> {
  private get newLanguageStore() {
    return this.props.newLanguage;
  }

  constructor(props: NewLanguageViewProps) {
    super(props);
    this.newLanguageStore.createNew({
      language: '',
      languageCode: '',
      hasTnaAvailable: false
    });
    this.state = {
      userClickedSaved: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewLanguageViewProps) {
    if (this.newLanguageStore.state.result && this.newLanguageStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onCreateNewItem() {
    this.setState({ userClickedSaved: true });
    this.newLanguageStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newLanguageStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.newLanguageStore.change({ ...this.newLanguageStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newLanguageStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New Language')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.newLanguageStore.state.result && !this.newLanguageStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newLanguageStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newLanguageStore.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    required
                    fluid
                    error={!this.newLanguageStore.state.item.language && this.state.userClickedSaved}
                    label={t('Language')}
                    placeholder={t('Name')}
                    value={this.newLanguageStore.state.item.language}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateLanguageDto>('language'), value)}
                  />
                  <Form.Input
                    required
                    fluid
                    error={!this.newLanguageStore.state.item.languageCode && this.state.userClickedSaved}
                    label={t('Code')}
                    placeholder={t('Code')}
                    value={this.newLanguageStore.state.item.languageCode}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateLanguageDto>('languageCode'), value)}
                  />
                  <Form.Checkbox
                    style={{ top: 25 }}
                    toggle
                    checked={this.newLanguageStore.state.item.hasTnaAvailable}
                    label={t('Available for tests')}
                    placeholder={t('Available for tests')}
                    onChange={(e, { checked }) => {
                      this.handleValue(nameof<CreateLanguageDto>('hasTnaAvailable'), checked);
                    }}
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewLanguageView);
